import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import React, { memo } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Button } from '../button';
export function DynamicDateFooter(props) {
  var extra = props.extra,
      className = props.className,
      _props$disableOk = props.disableOk,
      disableOk = _props$disableOk === void 0 ? false : _props$disableOk,
      onOk = props.onOk,
      onCancel = props.onCancel;
  var cls = classnames(usePrefixCls('dynamic-date-footer'), className);
  var extraCls = usePrefixCls('dynamic-date-footer-extra');
  var opCls = usePrefixCls('dynamic-date-footer-op');
  var locale = useLocale('date-picker.cancel');
  var apply = useLocale('date-picker.apply');
  var onOkCallback = useRefCallback(function () {
    !disableOk && onOk && onOk();
  });
  var onCancelCallback = useRefCallback(onCancel);
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: extraCls
  }, extra), React.createElement("div", {
    className: opCls
  }, React.createElement(Button, {
    size: 'sm',
    type: 'default',
    onClick: onCancelCallback
  }, locale), React.createElement(Button, {
    disabled: disableOk,
    size: 'sm',
    type: 'primary',
    onClick: onOkCallback
  }, apply)));
}
export default memo(DynamicDateFooter);